export const SEND_SERVERSIDE_FPTI_ACTION = 'FPTI/SERVERSIDE';
export const MAX_EVENTS_TO_LOG = 1000;
export const SERVERSIDE_FPTI_API = 'sendFPTIData';
export const COMP = 'creditapplyweb';
export const PROSPECT_PAYPAL_ACCOUNT_SIGNUP_IN_PROGRESS = 46;
export const PROSPECT_PAYPAL_ACCOUNT_SIGNUP_COMPLETE = 66;
export const NEW_CUSTOMER_VIEW_NAME = 'newCustomer';

export const SEND_CLIENTSIDE_FPTI_ACTION = 'FPTI/CLIENTSIDE';
export const DOM_EVENT = {
    FOCUS: 'focus',
    BLUR: 'blur',
    CLICK: 'click',
    CHANGE: 'change'
};
